<template>
  <div>
    <headerSection></headerSection>
    <div class="reward-page" :style="pageBackgroundStyle">
      <div class="container reward-shell">
        <section class="reward-hero">
          <div class="reward-hero__panel">
            <p class="reward-hero__eyebrow">
              <i class="fas fa-wallet"></i>
              Daily Cashback
            </p>
            <h1 class="reward-hero__title">คืนยอดเล่นอัตโนมัติ</h1>
            <p class="reward-hero__desc">
              ตรวจสอบยอดฝาก ถอน และยอดคืนล่าสุดของวันนี้ได้ในหน้าเดียว
              พร้อมโอนเข้ากระเป๋าหลักทันทีเมื่อมียอดพร้อมรับ
            </p>

            <div class="reward-chip-row">
              <span class="reward-chip">
                <i class="fas fa-piggy-bank"></i>
                พร้อมรับ {{ numberWithCommas(cashback.total) }}
              </span>
              <span class="reward-chip is-muted">
                <i class="fas fa-clock"></i>
                อัปเดตจากข้อมูลล่าสุดของระบบ
              </span>
            </div>
          </div>

          <div class="reward-hero__panel reward-hero__panel--compact">
            <div class="reward-media">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/cow-888.appspot.com/o/images%2F4135.jpg?alt=media&token=a94bd9a9-1bea-4b4e-bbaa-6f5b454c58e9&_gl=1*18zoq4g*_ga*MTQ3NzkyOTA2NS4xNjA4MTAzOTU5*_ga_CW55HF8NVT*MTY4NTg1OTM4My45My4xLjE2ODU4NTk0NjMuMC4wLjA."
                alt="คืนยอดเล่น"
                class="img-fluid"
              >
            </div>

            <div class="reward-note-list">
              <div class="reward-note">
                <i class="fas fa-money-bill-wave"></i>
                <div>
                  <strong>ดูยอดได้ชัด</strong>
                  <span>แยกยอดฝาก ถอน และยอดพร้อมรับให้ครบก่อนกดย้ายเงิน</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="reward-section">
          <div class="reward-section__header">
            <div>
              <h2 class="reward-section__title">สรุปยอดเล่น</h2>
              <p class="reward-section__subtext">
                ภาพรวมยอดเคลื่อนไหววันนี้ และยอด cashback ที่รอรับ
              </p>
            </div>

            <span class="reward-chip">
              <i class="fas fa-coins"></i>
              โอนเข้าได้เมื่อยอดมากกว่า 0
            </span>
          </div>

          <div class="reward-card-grid">
            <article
              v-for="card in cashbackCards"
              :key="card.key"
              :class="['reward-card', card.className]"
            >
              <p class="reward-card__label">{{ card.label }}</p>
              <p class="reward-card__value">{{ card.value }}</p>
              <p class="reward-card__caption">{{ card.caption }}</p>

              <div class="reward-card__footer">
                <span class="reward-card__meta">{{ card.meta }}</span>
                <span class="reward-card__icon">
                  <i :class="card.icon"></i>
                </span>
              </div>
            </article>
          </div>

          <div class="reward-action-row">
            <div>
              <button
                type="button"
                :class="['reward-button', { 'is-disabled': !canTransfer }]"
                :disabled="!canTransfer"
                @click="moveCashbackToWallet()"
              >
                <i class="fas fa-exchange-alt"></i>
                โอนเงินเข้ากระเป๋าหลัก
              </button>
              <span class="reward-button__subtext">
                ระบบจะอัปเดตข้อมูลให้อีกครั้งหลังทำรายการ
              </span>
            </div>
          </div>
        </section>

        <section class="reward-section reward-section--compact">
          <div class="reward-section__header">
            <div>
              <h2 class="reward-section__title">รายละเอียดเพิ่มเติม</h2>
              <p class="reward-section__subtext">
                เงื่อนไขและคำอธิบายของ cashback จากประกาศล่าสุด
              </p>
            </div>
          </div>

          <div class="reward-rich-text" v-html="nl2br(detail)"></div>
        </section>
      </div>
    </div>
    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
const axios = require('axios').default

export default {
  name: 'Cashback',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  data: function () {
    return {
      cashback: [],
      detail: ''
    }
  },
  computed: {
    pageBackgroundStyle () {
      return {
        backgroundImage: `linear-gradient(180deg, rgba(7, 13, 28, 0.32) 0%, rgba(7, 13, 28, 0.85) 100%), url(${require('../assets/images/Shiba-BG.jpg')})`
      }
    },
    canTransfer () {
      return !!(this.cashback && this.cashback.total > 0)
    },
    cashbackCards () {
      return [
        {
          key: 'deposit',
          label: 'ยอดฝาก',
          value: this.numberWithCommas(this.cashback.deposit),
          caption: 'ยอดฝากที่เข้าเงื่อนไขของวันล่าสุด',
          meta: 'Deposit',
          icon: 'fas fa-arrow-down',
          className: 'reward-card--info'
        },
        {
          key: 'withdraw',
          label: 'ยอดถอน',
          value: this.numberWithCommas(this.cashback.withdraw),
          caption: 'ยอดถอนที่ระบบใช้คำนวณ cashback',
          meta: 'Withdraw',
          icon: 'fas fa-arrow-up',
          className: ''
        },
        {
          key: 'total',
          label: 'ยอดคืนทั้งหมด',
          value: this.numberWithCommas(this.cashback.total),
          caption: 'ยอดที่พร้อมโอนกลับเข้ากระเป๋าหลัก',
          meta: 'Available now',
          icon: 'fas fa-coins',
          className: 'reward-card--accent reward-card--span-2'
        }
      ]
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    moveCashbackToWallet () {
      if (this.cashback.total && this.cashback.key) {
        this.$store.commit('user/SET_LOADING', true)
        axios.get(`https://api.cow888.fun/qcashback/cashback/${this.cashback.key}`)
        setTimeout(() => {
          this.getCashBack()
          this.$store.commit('user/SET_LOADING', false)
        }, 2000)
      }
    },
    numberWithCommas (x) {
      if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    nl2br (str, isXhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      const breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    async getCashBack () {
      this.detail = (await firebase.database().ref('/cashback/detail').once('value')).val()
      const user = this.getUserId()
      if (user) {
        firebase.firestore().collection('cashback').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.cashback = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.cashback = data
          })
        })
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getCashBack()
  }
}
</script>
